import { ScreenNames } from "@swiggy-private/portal-dineout-context";
import { ROUTES } from "../constants";
import { TabType } from "../types/cart";

export const getScreenName = (pathname: string, tab?: string) => {
    switch (pathname) {
        case ROUTES.MENU:
            return ScreenNames.MENU;
        case ROUTES.SEARCH:
            return ScreenNames.SEARCH;
        case ROUTES.COLLECTIONS:
            return ScreenNames.COLLECTION;
        // Cart and Track are a single /qr/cart-orders route with a `?tab=cart|orders` query param
        // (the legacy /qr/cart and /qr/track pages just redirect here), so the tab decides the screen.
        case ROUTES.CART_ORDERS:
            return tab === TabType.ORDERS ? ScreenNames.TRACK : ScreenNames.CART;
        default:
            return ScreenNames.MENU;
    }
};
